(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ClusterService', ClusterService)

    /** @ngInject */
    function ClusterService(HttpService) {
        const ClusterService = {
            get,
            getAll,
            getByParameters,
            post,
            put,
            deleteData
        }

        return ClusterService;

        function get(groupId) {
            return HttpService.get(`/clusters/${groupId}`);
        }

        function getAll() {
            return HttpService.get('/clusters/by-parameters', {
                params: {}
            });
        }

        function getByParameters(params) {
            return HttpService.get('/clusters/by-parameters', {
                params
            });
        }

        function post(groupData) {
            return HttpService.post('/clusters', groupData);
        }

        function put(groupData) {
            return HttpService.put('/clusters', groupData);
        }

        function deleteData(groupId) {
            return HttpService.delete(`/clusters/${groupId}`);
        }
    }
}());